/**
 * 2차원 배열들의 모든 조합 생성 (카르테시안 곱)
 * @example [[A,B], [1,2]] → [[A,1], [A,2], [B,1], [B,2]]
 */
export function getAllCombinations<T>(arrays: T[][]): T[][] {
  if (arrays.length === 0) return [[]];

  return arrays.reduce<T[][]>(
    (acc, curr) =>
      acc.length === 0
        ? curr.map((item) => [item])
        : acc.flatMap((accItem) => curr.map((currItem) => [...accItem, currItem])),
    [],
  );
}
